export default (msg, $store) => {
  const { commit } = $store;

  commit('_updateAgentsStatus', {
    status: msg.status,
    ts: msg.ts,
    id: msg.uid,
  });
};
